import { z } from 'zod'

export const responseFeedbackReasonsResponseSchema = z.object({
  negative_reasons: z.array(z.string()),
})
export type ResponseFeedbackReasonsResponse = z.infer<typeof responseFeedbackReasonsResponseSchema>
